import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { CustomButton } from '../../models/customButton';
import { CustomTableButtonComponent } from '../custom-table-button/custom-table-button.component';
import { ParserHtmlPipe } from '../../parser-html.pipe';

@Component({
  selector: 'app-custom-table',
  standalone: true,
  imports: [
    CommonModule, FormsModule, TableModule, InputTextModule,
    ButtonModule, IconFieldModule, InputIconModule,
    CustomTableButtonComponent, ParserHtmlPipe
  ],
  templateUrl: './custom-table.component.html',
  styleUrl: './custom-table.component.scss'
})
export class CustomTableComponent implements OnChanges {
  @Input() elements: any[] = [];
  @Input() headers: any[] = [];
  @Input() hasButton: boolean = false;
  @Input() showStatus: boolean = false;
  @Input() statusList: any[] = [];
  @Input() hasDownload: boolean = false;
  @Input() hasFilter: boolean = false;
  @Input() hasColumnFilter: boolean = true;
  @Input() actions: CustomButton[] = [];
  @Input() downloadOptions: any[] = [];
  @Input() rowsByPage: number = 10;
  @Input() canChecked = false;
  @Input() emptyTableMessage = 'No hay elementos para visualizar';
  @Output() downloadAction: EventEmitter<any> = new EventEmitter<any>();

  tableData: any[] = [];
  globalFilter: string = '';
  showDownloadMenu = false;
  rowsPerPageOptions = [10, 30, 50, 100];

  /** Visible headers for the template. */
  get visibleHeaders() {
    return this.headers.filter(h => h.visible && h.textHeader !== '');
  }

  get filterFields(): string[] {
    return this.visibleHeaders.map(h => h.key);
  }

  ngOnChanges(changes: SimpleChanges) {
    this.tableData = this.elements;
  }

  onDownload(value: any) {
    this.downloadAction.emit(value);
  }

  generateClass(value: any) {
    const found = this.statusList.find((s: any) => s.status === value?.toUpperCase());
    return found?.style || '';
  }
}
